<div [class]="classes" [attr.data-variant]="variant">
  <div class="label-large-prominent !font-bold text-on-surface-variant" data-testid="option-slider-title">{{ title | translate }}</div>

  <div
    class="relative flex items-center h-11 w-full cursor-pointer select-none touch-none focus-within:outline focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-primary"
    [class.cursor-grabbing]="isDragging"
    data-testid="option-slider-track"
    (pointerdown)="onPointerDown($event)"
    (keydown)="onKeydown($event)">
    <input
      type="range"
      class="sr-only"
      [min]="0"
      [max]="rangeMax"
      step="1"
      [value]="selectedIndex"
      [attr.aria-label]="title | translate"
      [attr.aria-valuetext]="displayedOptions[selectedIndex].label | translate"
      (input)="onRangeInput($event)"
    />
    <div
      class="flex items-center w-full h-7"
      [class.gap-[6px]]="showCutout"
      [class.pl-1]="showCutout && isAtStart"
      [class.pr-1]="showCutout && isAtEnd">
      <div
        class="h-4 min-w-0 bg-primary rounded-l-full"
        [class.hidden]="showCutout && isAtStart"
        [class.rounded-r-[2px]]="showCutout"
        [class.transition-[flex-grow]]="!isDragging"
        [class.duration-150]="!isDragging"
        [style.flex-grow]="fillPercent"
        data-testid="option-slider-active-track"></div>
      <div
        class="w-1 h-7 rounded-[2px] bg-primary shrink-0 pointer-events-none"
        data-testid="option-slider-handle"></div>
      <div
        class="h-4 min-w-0 bg-primary-container rounded-r-full"
        [class.hidden]="showCutout && isAtEnd"
        [class.rounded-l-[2px]]="showCutout"
        [class.transition-[flex-grow]]="!isDragging"
        [class.duration-150]="!isDragging"
        [style.flex-grow]="100 - fillPercent"
        data-testid="option-slider-inactive-track"></div>
    </div>
    <div
      *ngFor="let dot of dots"
      [class]="dot.className"
      [style.left]="dot.left"
      aria-hidden="true"
      data-testid="option-slider-dot"></div>
  </div>

  <div class="flex w-full">
    <button
      *ngFor="let option of displayedOptions; let i = index"
      type="button"
      class="label-large text-on-surface-variant bg-transparent border-0 p-0 m-0 appearance-none cursor-pointer min-w-0 flex-1 basis-0"
      [class.text-left]="i === 0"
      [class.text-center]="i > 0 && i < displayedOptions.length - 1"
      [class.text-right]="i === displayedOptions.length - 1"
      [attr.aria-pressed]="option.value === displayedOptions[selectedIndex].value"
      data-testid="option-slider-label"
      (click)="select(option.value)">
      {{ option.label | translate }}
    </button>
  </div>
</div>
